import Icon from '@/components/snippets/icon/icon'
import { AccountBadge } from './AccountBadge'
import { useOmneoClient } from '../hooks/useOmneoClient'
import { useEffect, useState } from 'preact/hooks'
import { formatMoney } from '@shopify/theme-currency'

/** Global */
const customerId = GM_STATE?.customer?.id
/** Global End */

const ProfileIcon = ({ hasTick }) => <Icon className={`w-6 ${hasTick ? 'h-6' : 'h-8'}`} id={hasTick ? 'account-tick' : 'profile'} />

const AvailableRewards = () => {
  const { client } = useOmneoClient()
  if (!client?.client) return <></>

  return <DisplayRewardBanner omneoClient={client} />
}

const DisplayRewardBanner = ({ omneoClient }) => {
  const [balance, setBalance] = useState({ reward_balance: 0 })

  const refreshBalance = () => {
    setTimeout(() => {
      omneoClient.profileClient.getBalance().then((data) => {
        if (!data) return
        setBalance(data)
      })
    }, 2000)
  }
  useEffect(() => {
    refreshBalance()
    window.addEventListener('omneo:refresh-balance', refreshBalance)
    return () => {
      window.removeEventListener('omneo:refresh-balance', refreshBalance)
    }
  }, [])
  if (balance?.reward_balance === 0) return <></>
  return <AccountBadge color="BLUE" title={`${formatMoney((balance?.reward_balance ?? 0) * 100)}`} />
}

/**
 * Custom Element: x-navigation-profile-icon
 *
 * Used to display the Profile icon on the site Navigation bar.
 * This is used for customers who are logged in.
 * This will display
 * 1) Total rewards available in their account
 * 2) Display if the customer is logged in
 */
export const NavigationProfileIcon = () => {
  if (!customerId) {
    return (
      <a href="/#account">
        <ProfileIcon />
      </a>
    )
  }
  return (
    <a href={'/account'} className={'flex flex-row gap-2 perspective-0'}>
      <div className={'relative flex items-center'}>
        <ProfileIcon hasTick={true} />
      </div>
      <AvailableRewards />
    </a>
  )
}
